import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    FormControlLabel,
    Switch,
    Button,
    Box
} from '@mui/material';

function PlataformaForm({ open, onClose, plataforma, onSave }) {
    const [formData, setFormData] = useState({
        codPlataforma: '',
        name: '',
        link: '',
        codVersion: '',
        codBuild: '',
        enabled: true,
        color: '#028DE7'
    });

    const isEditMode = plataforma && plataforma._id;

    useEffect(() => {
        if (plataforma) {
            setFormData({
                ...plataforma,
                codPlataforma: plataforma.codPlataforma || '',
                name: plataforma.name || '',
                link: plataforma.link || '',
                codVersion: plataforma.codVersion || '',
                codBuild: plataforma.codBuild || '',
                enabled: plataforma.enabled !== undefined ? plataforma.enabled : true,
                color: plataforma.color || '#028DE7'
            });
        } else {
            setFormData({
                codPlataforma: '',
                name: '',
                link: '',
                codVersion: '',
                codBuild: '',
                enabled: true,
                color: '#028DE7'
            });
        }
    }, [plataforma, open]);

    const handleChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleHexChange = (value) => {
        let v = value.trim();
        if (v && !v.startsWith('#')) v = `#${v}`;
        handleChange('color', v);
    };

    const isValidHex = (v) => /^#([0-9A-Fa-f]{6})$/.test(v || '');

    const handleSubmit = () => {
        onSave(formData);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ backgroundColor: '#3d4d87', color: 'white' }}>
                {isEditMode ? 'Editar Plataforma' : 'Nueva Plataforma'}
            </DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
                    <TextField
                        label="Código de la Plataforma"
                        value={formData.codPlataforma}
                        onChange={(e) => handleChange('codPlataforma', e.target.value.toUpperCase())}
                        fullWidth
                        required
                        disabled={isEditMode}
                    />
                    <TextField
                        label="Nombre"
                        value={formData.name}
                        onChange={(e) => handleChange('name', e.target.value)}
                        fullWidth
                        required
                    />
                    <TextField
                        label="Link"
                        value={formData.link}
                        onChange={(e) => handleChange('link', e.target.value)}
                        fullWidth
                        placeholder="https://..."
                    />
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <TextField
                            label="Build"
                            value={formData.codBuild}
                            onChange={(e) => handleChange('codBuild', e.target.value)}
                            sx={{ flex: 1 }}
                            placeholder="build-001"
                        />
                        <TextField
                            label="Versión"
                            value={formData.codVersion}
                            onChange={(e) => handleChange('codVersion', e.target.value)}
                            sx={{ flex: 1 }}
                            placeholder="1.0.0"
                        />
                    </Box>
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                        <TextField
                            label="Color"
                            type="color"
                            value={isValidHex(formData.color) ? formData.color : '#028DE7'}
                            onChange={(e) => handleChange('color', e.target.value)}
                            sx={{ width: 100 }}
                            InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                            label="Color (hex)"
                            value={formData.color || ''}
                            onChange={(e) => handleHexChange(e.target.value)}
                            placeholder="#028DE7"
                            inputProps={{ maxLength: 7 }}
                            error={!!formData.color && !isValidHex(formData.color)}
                            helperText={!!formData.color && !isValidHex(formData.color) ? 'Formato: #RRGGBB' : ''}
                            sx={{ flex: 1 }}
                        />
                    </Box>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={formData.enabled}
                                onChange={(e) => handleChange('enabled', e.target.checked)}
                                sx={{
                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                        color: '#3d4d87',
                                    },
                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                        backgroundColor: '#3d4d87',
                                    },
                                }}
                            />
                        }
                        label="Activo"
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{ padding: 2 }}>
                <Button onClick={onClose} sx={{ color: '#666' }}>
                    Cancelar
                </Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    sx={{ backgroundColor: '#3d4d87', '&:hover': { backgroundColor: '#2d3d67' } }}
                >
                    {isEditMode ? 'Guardar Cambios' : 'Crear'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default PlataformaForm;
